// images.js
import Freight from './Freight.png';
import Pborbit from './Pborbit/pickleball.avif'
import Milisync from './Milisync/leads.jpg'
import RedBeat from './RedBeat.png';
import Krivitech from './Krivitech.png';
import Socialoo from './Socialoo.png';
import TastyEats from './Tastyeats.png';
import Homyz from './Homyz.png'
import Catalix from './Catalix.png'


// TastyEats Images
import TEAbout from './TastyEats/About.png'
import TECartPage from './TastyEats/Cart-page.png'
import TECategories from './TastyEats/Categories.png'
import TEContactPage from './TastyEats/Contact.png'
import TECuisines from './TastyEats/Cuisines.png'
import TEDashboard from './TastyEats/dashboard-analytics.png'
import TEFaq from './TastyEats/FAQ.png'
import TEFavorite from './TastyEats/Favorite-items.png'
import TEFooter from './TastyEats/Footer.png'
import TEManageItems from './TastyEats/Manage-menu-items.png'
import TEManageUsers from './TastyEats/manage-users.png'
import TEMenuItemsPage from './TastyEats/Menuitems-page.png'
import TERatings from './TastyEats/Ratings.png'
import TETestimonials from './TastyEats/Testimonials-ui.png'
import TETrackOrders from './TastyEats/Track-orders.png'
import TEUploadNewItems from './TastyEats/Upload-new-menu.png'
import TEPayment from './TastyEats/Payment.png'
import TELogin from './TastyEats/Login.png'

// RedBeat Images
import RBCategory from './RedBeat/category.png';
import RBExerciseDetail from './RedBeat/exercise-details.png'
import RBExercises from './RedBeat/exercises.png'
import RBSimilarExercise from './RedBeat/similar-exercise.png'
import RBPagination from './RedBeat/pagination.png'
import RBVideo from './RedBeat/video-recommendations.png'

// Homyz Images


// Socialoo Images




// import all other images as needed
const images = {
    Freight,
    Pborbit,
    Milisync,
    RedBeat,
    Krivitech,
    Socialoo,
    TastyEats,
    Homyz,
    Catalix,

    RBCategory,
    RBExerciseDetail,
    RBExercises,
    RBPagination,
    RBSimilarExercise,
    RBVideo,

    TEAbout,
    TECartPage,
    TECategories,
    TEContactPage,
    TECuisines,
    TEDashboard,
    TEFaq,
    TEFavorite,
    TEFooter,
    TEManageItems,
    TEManageUsers,
    TEMenuItemsPage,
    TERatings,
    TETestimonials,
    TETrackOrders,
    TEUploadNewItems,
    TEPayment,
    TELogin,

};

export default images;
